import { useSupabaseClient } from "@/hooks/useSupabaseClient";
import type { Column } from "@/types/array.types";
import type { Database } from "@/types/database.types";
import { formatDateDisplay } from "@/utils/date";

const supabase = useSupabaseClient();
export const PAGE_SIZE = 15;

export type LogsType = Database["public"]["Tables"]["logs"]["Row"]

export type LogsTypeWithName = LogsType &  {
    profiles: 
      {
        id: string;
        full_name: string;
      }
  };

export const columns = [
    {
        key: "user", 
        label: "Utilisateur",
        render: (row) => row.profiles?.full_name ?? ""
    }, 
    {key: "operation", label: "Operation"}, 
    {
        key: "table_name", 
        label: "Table", 
    }, 
    {key: "created_at", label: "Date", render: (row) =>
            formatDateDisplay(row.created_at),},
] as Column<Partial<LogsTypeWithName>>[];

export const getLogs = async (page: number) => {
   const from = (page - 1) * PAGE_SIZE;
    const to = from + PAGE_SIZE - 1;

  const { data, count,  error } = await supabase
  .from("logs")
  .select(`
    *, 
     profiles (
      id,
      full_name
    )
  `,  { count: "exact" })
  .range(from, to)

  if (error) {
    console.error(error);
      return;
  } 

  return { data, count};
}